var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-2 flex gap-x-2 items-center"},[_c('label',{staticClass:"pt-1"},[_vm._t("default")],2),_vm._v(" "),(_vm.tooltip)?_c('Tooltip',{attrs:{"text":_vm.tooltip}},[_vm._v(" TOOLTIP ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }